import Button from '@/common/components/base/button/Button';
import MainModal from '@/common/components/base/modal/Modal';
import TitleDescription from '@/common/components/base/typography/TitleDescription';
import Typography from '@/common/components/base/typography/Typography';
import ScheduleVisitListComponent from '@/common/components/scheduleVisitListComponent/ScheduleVisitListComponent';
import TimeSetModal, {
  SetTimeFormType,
} from '@/common/components/scheduleVisitListComponent/TimeSetModal';
import LoadingPage from '@/common/pages/LoadingPage';
import { useCreateTimeSetQueryOptions } from '@/common/queries/createTimeSet/createTimeSetQueryOptions';
import { GetTimeSetsQueryResponseType } from '@/common/queries/getTimeSets/getTimeSetsQuery.type';
import { getTimeSetsQueryOptions } from '@/common/queries/getTimeSets/getTimeSetsQueryOptions';
import { convertPersianToGregorian } from '@/common/utils/convertPersianToGregorian';
import { fileEntryQueryOptions } from '@/modules/FileDetail/queries/fileEntry/fileEntryQueryOptions';
import { useQuery } from '@tanstack/react-query';
import React, { useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { Flex } from 'styled-system/jsx';

type Props = {
  open: boolean;
  setOpen: (value: boolean) => void;
  enableGetFileList: boolean;
};
const PropertyScheduleVisit: React.FC<Props> = (props) => {
  const { open, setOpen, enableGetFileList } = props;
  const [openTimeSetModal, setOpenTimeSetModal] = useState(false);
  const { id } = useParams();
  const methods = useForm();
  const { refetch: getFileDetail } = useQuery(fileEntryQueryOptions(id!));
  const {
    data: fileList,
    refetch: refetchFileList,
    isPending,
  } = useQuery(
    getTimeSetsQueryOptions({
      fileId: id!,
      enableGetFileList: enableGetFileList,
    }),
  );
  const [selectedDamagedList, setSelectedDamagedList] = useState<
    GetTimeSetsQueryResponseType[]
  >([]);
  const { mutate } = useCreateTimeSetQueryOptions();

  const onSubmit = () => {
    setOpenTimeSetModal(true);
  };

  const onSubmitForm = (data: SetTimeFormType) => {
    const damages = selectedDamagedList.map((item) => ({
      user_type: item?.user_type?.const ?? item?.user_type,
      id: item?.id,
    }));
    const formData: any = {
      adjuster_visit_date: convertPersianToGregorian(data.adjuster_visit_date),
      adjuster_visit_time: data.adjuster_visit_time,
      visit_location: data.visit_location,
      visit_location_phi: null,
      visit_location_lambda: null,
    };
    if (damages.length > 0) {
      formData.damages = damages;
    }
    mutate(
      { id: id!, data: formData },
      {
        onSuccess: () => {
          setOpenTimeSetModal(false);
          setOpen(false);
          getFileDetail();
          setSelectedDamagedList([]);
          refetchFileList();
        },
      },
    );
  };

  const handleChange = (item: any) => {
    const isElementExist = selectedDamagedList?.find(
      (item2) => item2?.id === item?.id,
    )?.id;

    if (!isElementExist) {
      setSelectedDamagedList((prev) => [...prev, item]);
    } else {
      setSelectedDamagedList((prev) =>
        prev.filter((item2) => item2.id !== item.id),
      );
    }
  };

  useEffect(() => {
    if (fileList) {
      setSelectedDamagedList(...[fileList ?? []]);
    }
  }, [fileList]);
  return (
    <FormProvider {...methods}>
      <MainModal open={open} closeModal={() => setOpen(false)}>
        <TitleDescription>
          <Typography textStyle="h2">تعیین زمان بازدید</Typography>
        </TitleDescription>
        <Typography textStyle="b2" mt="24px">
          کارشناس عزیز، در این بخش می‌توانید زمان بازدید را برای هر یک از طرفین
          حادثه تعیین نمایید؛ در صورت انتخاب چند نفر به صورت همزمان زمان بازدید
          به صورت گروهی تعیین خواهد شد.
        </Typography>
        <Flex
          flexDirection="column"
          gap={16}
          mt={24}
          maxHeight="400px"
          overflowY="auto"
        >
          {(fileList?.length ?? 0) > 0 && !isPending ? (
            fileList?.map((item: any) => (
              <ScheduleVisitListComponent
                key={item.id}
                listData={item}
                onChange={handleChange}
                checked={
                  selectedDamagedList.find((item2) => item2.id === item?.id)?.id
                    ? true
                    : false
                }
              />
            ))
          ) : (
            <LoadingPage />
          )}
        </Flex>
        <Button
          onClick={methods.handleSubmit(onSubmit)}
          disabled={selectedDamagedList?.length === 0}
          fullWidth
          mt={24}
        >
          تعیین/ ویرایش زمان بازدید
        </Button>
        <TimeSetModal
          open={openTimeSetModal}
          closeModal={() => setOpenTimeSetModal(false)}
          onSubmitForm={(data) => {
            onSubmitForm(data);
          }}
        />
      </MainModal>
    </FormProvider>
  );
};

export default PropertyScheduleVisit;
